const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../../lib/evaluateSource');
const {
  getAssignmentGroups,
  processAssignments
} = require('../../lib/irtc/assignmentGroups');

/**
  * @function evalute - evaluate itiAssignmentGroupsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const assignmentGroups = getAssignmentGroups();
  const checklists = await evaluateSource(source.checklists, content, parentContentPath, transientContext, nativeFunctions);
  if (checklists === undefined || !isPlainObject(checklists)) {
    return assignmentGroups;
  }
  processAssignments(checklists, (identifier, plusOpen, plusComplete) => {
    if (identifier !== undefined) {
      const item = assignmentGroups[identifier] || {};
      const {
        open = 0,
        complete = 0
      } = item;
      item.open = open + plusOpen;
      item.complete = complete + plusComplete;
    }
  });
  Object.keys(assignmentGroups).forEach(key => {
    const value = assignmentGroups[key];
    if (value.open > 0 || value.complete > 0) {
      value.subtitle = `Open: ${value.open} Complete: ${value.complete}`;
      delete value.open;
      delete value.complete;
    } else {
      delete assignmentGroups[key];
    }
  });
  return assignmentGroups;
};
module.exports = {
  evaluate
};